<div class="visual-itinerary">
    <finder-generic-text [data]="data"></finder-generic-text>
    <div class="days">
        <div class="day" *ngFor="let day of data?.days">
            <div class="heading">{{day.heading}}</div>
            <div class="agenda">
                <div
                    class="agenda-item"
                    class="{{item.style}}"
                    [ngClass]="{'symbol-present': item?.symbol, 'off-property': item?.offProperty}"
                    *ngFor="let item of day?.agenda"
                >
                    <div class="symbol" *ngIf="item.symbol">
                        <finder-font-icon svg="true" [name]="item.symbol" size="m"></finder-font-icon>
                    </div>
                    <div class="title">{{item.title}}</div>
                    <div class="text dynamic-html" *ngIf="item.text" [innerHTML]="item.text | safeHtml"></div>
                    <div class="time">
                        <span class="hours">{{item.startTime?.time}}</span> {{item.startTime?.meridiem}}
                        <span *ngIf="item.endTime">
                            {{data.labels?.to}} <span class="hours">{{item.endTime?.time}}</span> {{item.endTime?.meridiem}}
                        </span>
                    </div>
                    <div class="feature" *ngIf="item.feature">{{item.feature}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="disclaimer dynamic-html" [innerHTML]="data?.disclaimer | safeHtml"></div>
</div>
